import { lazy } from "react";
import { PATHS } from "@/lib/router";

const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const ComponentsShowcase = lazy(() => import("./pages/ComponentsShowcase"));

const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const dashboardRoutes = [
  {
    path: PATHS.DASHBOARD,
    element: <DashboardPage />,
    handle: {
      permission: { resource: "company_information", action: "view" },
      blacklistGroup: [
        "system_admin",
        "business_unit",
        "bank_admin",
        "sme_user",
      ],
    },
  },
  ...(isLocalhost
    ? [
        {
          path: PATHS.COMPONENTS,
          element: <ComponentsShowcase />,
        },
      ]
    : []),
];
